module.exports = __webpack_public_path__ + "img/2009.9be37c79.png";